import type { EditableRecipientType } from './useQuoteRecipientRows'

export const QUOTE_RECIPIENTS_NOTIFY_LIST_COPY = {
  allRecipients: 'All recipients',
  counterSignerLastNote: 'Countersigners will be notified last.',
  learnMore: 'Learn more',
  esignatureDocsUrl: 'https://docs.sequencehq.com/cpq/esignature',
  kindLabel: {
    SIGNER: 'Signer',
    CC: 'CC',
    COUNTER_SIGNER: 'Countersigner'
  }
} as const

export const RECIPIENT_TYPE_OPTIONS = [
  {
    value: 'SIGNER',
    label: QUOTE_RECIPIENTS_NOTIFY_LIST_COPY.kindLabel.SIGNER
  },
  { value: 'CC', label: QUOTE_RECIPIENTS_NOTIFY_LIST_COPY.kindLabel.CC }
]
